@import (reference) '../../../../../../../constants/spacing.module.less';

.delete-blocked-row {
  flex-wrap: nowrap;
  align-items: flex-start;
  padding: @space-16;
  background-color: var(--gray-F4F6F8);
  border-radius: @space-8;
}

.delete-blocked-icon {
  color: var(--gold-500);
  font-size: 16px;
  flex-shrink: 0;
  margin-top: 3px;
}

.delete-blocked-content {
  min-width: 0;
}

.delete-blocked-tags {
  align-items: center;
  margin-top: @space-4;
}

.delete-blocked-tag {
  display: inline-block;
  padding: 2px @space-8;
  background-color: var(--gray-DFE4E8);
  border-radius: @space-4;
}
